import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const exportToExcel = (data, filename = 'export.xlsx') => {
  try {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, filename);
    return true;
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    return false;
  }
};

export const exportMembersToExcel = (members, formatCurrency, formatDate) => {
  const exportData = members.map(member => ({
    'Name': member.name,
    'Email': member.email,
    'Phone': member.phone,
    'Emergency Contact': member.emergency_contact,
    'Join Date': formatDate(member.join_date),
    'Status': member.status,
    'Admission Fee': member.admission_fee_amount ? formatCurrency(member.admission_fee_amount) : '-',
    'Admission Paid': member.admission_fee_paid ? 'Yes' : 'No',
    'Gender': member.gender || '-',
    'Height (cm)': member.height || '-',
    'Weight (kg)': member.weight || '-'
  }));
  
  return exportToExcel(exportData, `members_${new Date().toISOString().split('T')[0]}.xlsx`);
};

export const printMembersList = async (tableElement, title = 'Members List') => {
  try {
    const canvas = await html2canvas(tableElement, {
      scale: 2,
      useCORS: true,
      logging: false
    });
    
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });
    
    const imgWidth = 277; // A4 landscape width minus margins
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    // Add title
    pdf.setFontSize(18);
    pdf.text(title, 148.5, 15, { align: 'center' });
    
    // Add image
    pdf.addImage(imgData, 'PNG', 10, 25, imgWidth, imgHeight);
    
    // Print
    pdf.autoPrint();
    window.open(pdf.output('bloburl'), '_blank');
    
    return true;
  } catch (error) {
    console.error('Error printing list:', error);
    return false;
  }
};

export const exportMembersListToPDF = async (tableElement, title = 'Members List') => {
  try {
    const canvas = await html2canvas(tableElement, {
      scale: 2,
      useCORS: true,
      logging: false
    });
    
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });
    
    const imgWidth = 277;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    pdf.setFontSize(18);
    pdf.text(title, 148.5, 15, { align: 'center' });
    pdf.addImage(imgData, 'PNG', 10, 25, imgWidth, imgHeight);
    
    pdf.save(`${title.toLowerCase().replace(/ /g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
    
    return true;
  } catch (error) {
    console.error('Error exporting to PDF:', error);
    return false;
  }
};